import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { FilterActions, ToggleActions } from '../../constants/constants';
import { filterChange, toggleSwitch } from '../../actions';
import { _ } from '../../functions/translator';

class OnStageHelpIcon extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
            openDelay: 1000,
        }
    }

    componentDidMount() {
        if (window.pending_full_tutorial || window.pending_last_updates_tutorial) {
            setTimeout(() => {
                this.handleHelp();
                if (window.pending_full_tutorial) {
                    this.handleOpenDemo();
                } else {
                    this.handleOpenLastUpdates();
                }
            }, this.state.openDelay);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.open) {
            if (this.background) this.background.classList.add('circle-background-animation');
            if (this.tutorialButton) this.tutorialButton.classList.add('tutorial-button');
            if (this.lastUpdatesButton) this.lastUpdatesButton.classList.add('last-updates-button');
        }
        if (!this.state.open || (this.props.demo !== prevProps.demo && !this.props.demo)) {
            if (this.background) this.background.classList.remove('circle-background-animation');
            if (this.tutorialButton) this.tutorialButton.classList.remove('tutorial-button');
            if (this.lastUpdatesButton) this.lastUpdatesButton.classList.remove('last-updates-button');
            if (this.state.open) {
                this.handleCloseHelp();
            }
        }
    } 

    handleHelp = () => {
        this.setState({ open: !this.state.open });
    }

    handleCloseHelp = () => {
        this.setState({ open: false });
    }

    handleOpenDemo = () => {
        this.props.filterChange(FilterActions.DEMO_URL, window.full_tutorial_url);
        this.props.toggleSwitch(ToggleActions.DEMO, true);
    }

    handleOpenLastUpdates = () => {
        this.props.filterChange(FilterActions.DEMO_URL, window.last_updates_tutorial_url);
        this.props.toggleSwitch(ToggleActions.DEMO, true);
    }

    render() {
        if (this.props.popUpMenu.show) return <div></div>;
        const tutorialPulseClass = window.pending_full_tutorial ? 'pulse' : '';
        const lastUpdatesPulseClass = window.pending_last_updates_tutorial ? 'pulse' : '';
        return(
            <div className='help-icon-layout'>
                <div className="circle-background" ref={ref => this.background = ref} onClick={this.handleCloseHelp}/>
                <div className='help-icon-container'>
                    <IconButton className='help-button p-2' onClick={this.handleHelp}>
                        <HelpOutlineIcon fontSize='large'/>
                    </IconButton>
                    <div 
                        className={`popup-menu-button help-transition-1 card-color pl-3 ${tutorialPulseClass}`}
                        ref={ref => this.tutorialButton = ref} 
                        onClick={this.handleOpenDemo}>
                        <p>{ _('Ver Tutorial') }</p>
                    </div>
                    <div 
                        className={`popup-menu-button help-transition-2 card-color pl-3 ${lastUpdatesPulseClass}`}
                        ref={ref => this.lastUpdatesButton = ref} 
                        onClick={this.handleOpenLastUpdates}>
                        <p>{ _('Ver Últimos Cambios') }</p>
                    </div>
                </div>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        demo      : state.switches.demo,
        popUpMenu : state.popUpMenu,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        filterChange : filterChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(OnStageHelpIcon);